/*jshint esversion: 11 */

import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';

window.swpchero = () => {
    "use strict";
    return {
        swiper: null,
        activeIndex: 2,
        init() {
            let alp = this;
            this.swiper = new Swiper('.swp', {
                effect: 'coverflow',
                grabCursor: false,
                centeredSlides: true,
                slidesPerView: 'auto',
                coverflowEffect: {
                    rotate: 0,
                    stretch: 2,
                    depth: 12,
                    modifier: 80,
                    slideShadows: false,
                },
                a11y: {
                    slideLabelMessage: "",
                },
                mousewheel: {
                    enabled: true,
                    forceToAxis: true
                },
                initialSlide: 2,
                on: {
                    init(swiper) {
                        setTimeout(() => markVisibleSlides(swiper), 0);
                    },
                    slideChange: function (s) {
                        markVisibleSlides(s);
                        alp.activeIndex = this.realIndex;
                    }
                },
                pagination: {
                    el: '.swiper-pagination',
                },
                loop: true,
                autoplay: {
                    delay: 2000,
                },
            });
        }
    };
};


function markVisibleSlides(swiper) {
    "use strict";
    const slides = swiper.slides;
    const total = slides.length;

    slides.forEach((slide) => {
        slide.classList.remove("swiper-slide-prev-2", "swiper-slide-next-2");
    });

    const activeIndex = swiper.activeIndex;

    // Função para obter índice válido com loop
    const getIndex = (i) => (i + total) % total;

    const prev2Index = getIndex(activeIndex - 2);
    const next2Index = getIndex(activeIndex + 2);

    slides[prev2Index]?.classList.add("swiper-slide-prev-2");
    slides[next2Index]?.classList.add("swiper-slide-next-2");
}


window.swpcheroImage = () => {
    "use strict";
    return {
        swiper: null,
        init() {
            let alp = this;
            this.swiper = new Swiper('.swp-hero-header', {
                centeredSlides: true,
                slidesPerView: 1,
                a11y: {
                    slideLabelMessage: "",
                },
                mousewheel: {
                    enabled: true,
                    forceToAxis: true
                },
                autoplay: {
                    delay: 5000,
                },
            });
        }
    };
};

